<div class="page" data-automation-id="login-page-container" (keyup.enter)="login()">
    <div class="topBar" data-automation-id="top-nav-container">
        <li class="dropdown on-hover about-section" dropdown>
            <div dropdownToggle role="button" class="help-action" data-automation-id="login-help-dropdown-button">
                <i class="fa fa-question fa-icon resizing-icon"></i>
                <span data-automation-id="login-help-label">Help</span>
                <i class="fa fa-caret-down help-caret"></i>
            </div>
            <ul *dropdownMenu class="dropdown-menu dropdown-menu-right">
                <li class="menu-item" data-automation-id="login-about-button" (click)="openAboutModal()">
                    <div class="about-icon">
                        <i class="fa fa-info-circle"></i>
                    </div>
                    <div class="about-label">About Reef ECA ...</div>
                </li>
            </ul>
        </li>
    </div>
    <div class="titleBar">
        <img class="titleImage" src="assets/images/ReefECA_logo_TP_Color.png" data-automation-id="login-logo-image">
        <div class="welcomeText" data-automation-id="login-welcome-message">
        </div>
    </div>
    <div class="background">
</div>
    <div class="footer" data-automation-id="login-footer-message">
        <div class="version">
            <span>Copyright © 2007-2026. Digital Reef, Inc. All Rights Reserved</span>
            <span>Portions of this program suite are licensed under United States Patent No. 6,918,082.</span>
            <span #drVersion>{{"R5.5.4.1-d5135269502926d5-39442464f492ed4c"}}</span>
        </div>
        <button type="button" class="btn cert-button" (click)="openCertificateModal()"
            data-automation-id="login-install-cert-button">Install Reef ECA Server CA Certificate ...</button>
    </div>
    <div class="login-body" [resBusySpinner]="isBusy" [message]="isBusyMessage"
        *ngIf="isStandardAuthentication && !isBusyTpAuth">
        <div class="content-box">
            <div class="text-column">
                <div [hidden]="!isServerShown" class="server">Server</div>
                <div>Username</div>
                <div>Password</div>
            </div>
            <form class="input-column" [ngClass]="[!passwordIsDisabled ? '' : 'hide-icons']">
                <res-custom-checkbox name="mock" [(ngModel)]="mock" content="Local Mock Server"
                    [hidden]="!isServerShown"></res-custom-checkbox>
                <input type="text" [(ngModel)]="url" name="url" [hidden]="!isServerShown || mock">
                <input type="text" [(ngModel)]="username" name="username" data-automation-id="login-user-name-input"
                    autocomplete="username" (ngModelChange)="usernameOnChange()">
                <ng-template #dualPopTmpl><span data-automation-id="login-error-bad-auth-message">Invalid "Username"
                        and/or "Password"</span><i class="fa fa-close" (click)="dualPop.hide()"></i></ng-template>

                <span class="error-popover" containerClass="error" container="body" [popover]="dualPopTmpl" triggers=""
                    #dualPop="bs-popover" placement="right"></span>
                <div class="password-container">
                    <input type="password" [(ngModel)]="password" name="password"
                        data-automation-id="login-password-input" autocomplete="current-password" resIconSwitch
                        initClass="fa fa-eye" switchClass="fa fa-eye-slash" elementAttributeName="type"
                        elementAttributeValue="text" [disabled]="passwordIsDisabled">
                    <button type="button" data-automation-id="login-edit-password-button" *ngIf="passwordIsDisabled"
                        (click)="editStoredPassword()" class="edit-password-button"
                        title="Edit password. The current password will be &quot;forgotten&quot; once you successfully log in with a new one.">
                        <i class="fa fa-pencil color-blue-01"></i>
                    </button>
                </div>

                <div class="options">
                    <res-custom-checkbox name="rememberMe" automationId="login-remember-me" [(ngModel)]="rememberMe"
                        content="Remember Me"></res-custom-checkbox>
                    <button type="button" class="btn btn-link" (click)="changePassword()"
                        data-automation-id="login-change-password-link">Change Password ...</button>
                </div>
            </form>
        </div>
        <button type="button" data-automation-id="login-button" class="primary-button" (click)="login()"
            [disabled]="verifyFields()">Log In</button>
    </div>
    <div class="login-body transperfect-auth-body" *ngIf="isTPAuthEnabledSystem && !isBusyTpAuth">
        <button type="button" data-automation-id="transperfect-login-button" class="primary-button"
            (click)="transPerfectAuthentication()">Log In</button>
    </div>
    <div class="spinner-transperfect-auth" [resBusySpinner]="isBusyTpAuth" [message]="isBusyMessage"></div>
</div>
<ng-template #certificateTemplate>
    <div style="width:650px">
        <p>If you have a VeriSign-signed certificate for your Reef ECA Server, you can skip this procedure.</p>
        <p></p>
        <p>To establish the Reef ECA Server as a Certificate Authority, enabling HTTPS access to your Reef ECA
            Server,
            you must install the CA certificate available for your Reef ECA Server:</p>
        <p></p>
        <p>&nbsp;&nbsp;&nbsp;1.&nbsp;&nbsp;&nbsp;Right-click the link below and save the CA certificate to your desktop
            with a .DER extension.</p>
        <p>&nbsp;&nbsp;&nbsp;2.&nbsp;&nbsp;&nbsp;From the desktop, double-click the saved CA certificate to begin the
            installation of the CA certificate.</p>
        <a href="./certificates/digitalreef-ca.der" data-automation-id="cert-install-link">Reef ECA Server CA
            Certificate</a>
    </div>
</ng-template>
<ng-template #aboutTemplate>
    <div style="width:365px">
        <span>Copyright © 2007-2026. Digital Reef, Inc. All Rights Reserved</span>
        <p></p>
        <span>Portions of this program suite are licensed under United States Patent No. 6,918,082.</span>
        <p></p>
        <span>{{"R5.5.4.1-d5135269502926d5-39442464f492ed4c"}}</span><br />
        <span>{{"2026-09-03 16:11"}}</span>
    </div>
</ng-template>
